import { AnyAction } from 'redux';
import { GDPRActions } from 'actions';

export interface GdprState {
  open: boolean;
  success: boolean;
  // result/error are opaque values passed straight through from the action payload
  result: unknown;
  error: unknown;
}

const initialState: GdprState = {
  open: false,
  success: false,
  result: null,
  error: null,
};

export const gdpr = (state: GdprState = initialState, action: AnyAction): GdprState => {
  switch (action.type) {
    case GDPRActions.UPDATE_PERSONAL_DATA_TRACKING_RESULT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default gdpr;
